module.exports = __webpack_public_path__ + "img/trendformer-2.c3a38e53.png";